import Head from "next/head";
import StartHumming from "pages/components/StartHumming";
import React from "react";
import { ExtendedNextPage } from "types/pages";

import Content from "components/Content";
import Label from "components/Label";
import HummingNav from "pages/components/HummingNav";
import HummingFooter from "pages/components/HummingFooter";
import styles from "./styles.module.scss";
import { terms } from "./constants";

const Terms: ExtendedNextPage = () => {
  return (
    <div className={styles.container}>
      <Head>
        <title>Terms and Conditions | Humming Homes</title>
        <meta
          name="description"
          content="Terms and Services around the Humming Homes subscription. "
        />
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://humminghomes.com/terms" />
      </Head>
      <Content contentClassName={styles.terms}>
        <Label className={styles.title} variant="h1-centered" color="primary">
          Terms of use
        </Label>
        <Label color="primary" useMarkdown>
          {terms}
        </Label>
      </Content>
      <StartHumming fillColor="primary" />
    </div>
  );
};

Terms.getLayout = (page) => {
  return (
    <div>
      <HummingNav />
      {page}
      <HummingFooter />
    </div>
  );
};

export default Terms;
